<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="taxgroup"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="
      this.page == 'update'
        ? submitted == true
          ? loaderIcon + 'Update'
          : 'Update'
        : submitted == true
        ? loaderIcon + 'Save'
        : 'Save'
    "
    @ok.prevent="onSubmit"
    title="Add Tax Group"
    ref="taxgroup"
    :ok-disabled="submitted"
    @shown="
      page == 'create' ? createFreshEventObject() : updateFreshEventObject()
    "
    scrollable
  >
    <b-alert
      class="alert-transparent alert-danger"
      :show="error_show && (this.errors.any() || message != '')"
    >
      <button type="button" @click="error_show = !error_show" class="close">
        <span aria-hidden="true">&times;</span>
      </button>
      <p class="fw-semi-bold" v-if="errors.has('Tax Name')">
        {{ errors.first("Tax Name") }}
      </p>
      <p class="fw-semi-bold">{{ message }}</p>
    </b-alert>

    <b-row class="m-0" v-if="page == 'create' || page == 'update'">
      <b-col class="px-0">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="'Tax Name'"
          label-class="required"
          label-for="tax_name"
        >
          <b-form-input
            type="text"
            size="sm"
            name="Tax Name"
            v-model.trim="field.tax_name"
            v-validate="'required|max:100'"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div>
      <table class="table table-bordered reports-table-border">
        <thead>
          <th class="text-center" style="width: 45px !important"></th>
          <th style="width: 310px !important">Tax Name</th>
          <th style="width: 110px !important">Rate (%)</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in details.tax_rates" :key="item.id">
            <td>
              <div
                class="abc-checkbox text-center"
                style="padding-left: 10px !important"
              >
                <input
                  type="checkbox"
                  v-model.trim="checkboxes1[index]"
                  :id="'checkbox' + index"
                  :true-value="item.tax_id"
                  @input="is_change=1"
                />
                <label :for="'checkbox' + index" />
              </div>
            </td>

            <td style="width: 310px !important">
              <span class="text">{{ item.tax_name }}</span>
            </td>
            <td>{{ item.tax_percent }}</td>
          </tr>
        </tbody>
      </table>
        <div v-if="page=='update'&&is_change==1">
             <p>The updated taxes will reflect in the following transaction(s), wherever the tax group has been applied. Select the boxes below to update the taxes in them.</p>
              <b-form-checkbox
                      plain
                      v-model.trim="field.update_draft_inv"
                      name="update_draft_inv"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                    >Draft Invoices
                </b-form-checkbox>
                 <b-form-checkbox
                      plain
                      v-model.trim="field.update_rec_trans"
                      name="update_rec_trans"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                      disabled
                    >Recurring Transactions
                </b-form-checkbox>
                <p class="fw-semi-bold">Terms and Conditions</p>
                    <b-form-checkbox
                      plain
                      v-model.trim="field.terms_and_conditions"
                      name="Terms and Conditions"
                      :true-value="1"
                      :false-value="0"
                      class="mb-4"
                    >I understand that updating the tax will mark the existing tax inactive, create a new tax, and update it in the chosen transactions.
                </b-form-checkbox>
         </div>
    </div>
  </b-modal>
</template>
<script>
import $ from "jquery"; // for using jquery function
import { mapState } from "vuex";
export default {
  props: ["page", "detailupdate", "list"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      checkboxes1: [],
      error_show: false,
       is_change:0,
      message: "",
      field: {
        tax_name: "",
        tax_ids: "",
        tax_type: [],
        tax_state: "",
        update_rec_trans:true,
        update_draft_inv :0,
        terms_and_conditions:""
      },
      tax_ids: [],
    };
  },
  methods: {
    createFreshEventObject() {
      this.field = {
        tax_name: "",
        tax_ids: "",
        tax_state: "",
        update_rec_trans:"",
        update_draft_inv:"",
        terms_and_conditions:""
      };
      this.error_show = false;
      this.tax_ids = [];
      this.message = "";
      this.checkboxes1 = [];
    },
    validateSelectedtax() {
      return new Promise((resolve, reject) => {
        var message = "";
        var tax_type = [],
          tax_percent = [];
        this.field.tax_type = [];

        for (var i = 0; i <= this.checkboxes1.length; i++) {
          if (
            this.checkboxes1[i] != "" &&
            this.checkboxes1[i] != false &&
            typeof this.checkboxes1[i] != "undefined"
          ) {
            this.field.tax_type.push(this.details.tax_rates[i].tax_type);
            tax_type[this.details.tax_rates[i].tax_type] = !isNaN(
              tax_type[this.details.tax_rates[i].tax_type]
            )
              ? parseInt(tax_type[this.details.tax_rates[i].tax_type]) + 1
              : parseInt(1);
            tax_percent[this.details.tax_rates[i].tax_percent] = !isNaN(
              tax_percent[this.details.tax_rates[i].tax_percent]
            )
              ? parseInt(tax_percent[this.details.tax_rates[i].tax_percent]) + 1
              : parseInt(1);
          }
        }
        this.field.tax_state =
          typeof tax_type[3] != "undefined"
            ? "2"
            : typeof tax_type[1] != "undefined"
            ? "1"
            : typeof tax_type[2] != "undefined"
            ? "1"
            : "";

        if (tax_percent["0.00"] > 0 && Object.keys(tax_percent).length > 1) {
          message = "You cannot create the tax group with Zero rate.";
        } else if (tax_type[1] > 1 || tax_type[2] > 1 || tax_type[3] > 1|| tax_type[4] > 1|| tax_type[5] > 1) {
          message = "You cannot group same type of taxes in single tax group.";
        } else if (
          tax_type[3] > 0 &&
          (tax_type[1] > 0 || tax_type[2] > 0 || tax_type[4] > 0)
        ) {
          message = "You cannot group IGST with CGST,UTGST and/or SGST ";
        } else if (tax_type[4] > 0 && tax_type[2] > 0) {
          message = "You cannot group UTGST with SGST.";
        } else if (Object.keys(tax_type).length <= 1) {
          message = "Select atleast two taxes";
        }
         else if(!this.field.terms_and_conditions&&this.page=='update'&&this.is_change==1){
          message="Please read and accept the Terms and Conditions"
        }
         else if (
          this.list.tax_state != null &&
          this.list.tax_state != this.field.tax_state &&
          this.list.is_used > 0
        ) {
          message = "Tax type cannot be changed hence used in transaction";
        } else {
          var tax_ids = this.checkboxes1;
          this.field.tax_ids = tax_ids.filter((item) => item !== false);
        }
        resolve(message);
      });
    },
    updateFreshEventObject() {
      this.error_show = false;
      this.field.update_rec_trans=true,
      this.is_change=0;
      this.field.tax_name = this.list.tax_name;
      this.field.tax_ids = this.list.tax_ids;
      this.field.tax_state = JSON.stringify(this.list.tax_state);
      this.tax_ids = this.list.tax_ids.split(",");
      for (var i = 0; i < this.details.tax_rates.length; i++) {
        if (this.tax_ids.indexOf(this.details.tax_rates[i].tax_id) > -1) {
          this.checkboxes1[i] = this.details.tax_rates[i].tax_id;
        } else {
          this.checkboxes1[i] = false;
        }
      }
    },
    async onSubmit() {
      await this.$validator.validateAll().then((result) => {
        if (result) {
          this.validateSelectedtax().then((response) => {
            if (response == "") {
              var data = JSON.stringify(this.field);
              var url = "createtaxgroup";
              this.submitted = true;
              if (this.page == "update") {
                url = "updatetaxgroup";
                data = {
                  id: this.list.tax_id,
                  data: JSON.stringify(this.field),
                };
              }

              this.$store.dispatch("taxgroup/" + url, data).then(() => {
                 this.submitted = false;
                if (this.type != "danger") {
                 
                  this.$emit("updateTaxpage");
                  this.$refs.taxgroup.hide();
                }
                // to show the alert message for success or error after api call
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: this.messages,
                  type: this.type,
                  showCloseButton: true,
                });
              });
            } else {
              // Scroll to error message show
              $(".modal-body").scrollTop(0);
              this.submitted = false;
              this.message = response;
              this.error_show = true;
            }
          });
        } else {
          // Scroll to error message show
          $(".modal-body").scrollTop(0);
          this.error_show = true;
          this.submitted = false;
        }
      });
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.taxgroup.details,
      messages: (state) => state.taxgroup.message,
      type: (state) => state.taxgroup.type,
    }),
  },
};
</script>
